// extracted by mini-css-extract-plugin
export default {"container":"i6Pa5pRNEx4HZ98tUx9f","bodyContainer":"JhuQhqhvUrnoF6syaOS5"};